
import React, { useEffect } from "react";
import { Col, Container, Nav, Row } from '@themesberg/react-bootstrap';
import { Routes } from "../../routes";
import { useCookies } from "react-cookie";
import { logout } from "../../controller/api/auth";
import { useHistory } from "react-router-dom";

export default () => {

  const [cookies, , removeCookie] = useCookies(['wvivu']);

  const permission = localStorage.getItem('permission') ? localStorage.getItem('permission').split('') : []

  const history = useHistory()

  const handleLogout = async () => {
    try {
      await logout(cookies.wvivu)
    } catch (error) {

    } finally {
      removeCookie('wvivu')
      history.replace('/')
    }
  }

  useEffect(() => {
    document.title = "Trang chủ"
  }, []);

  return (
    <main style={{ height: '100vh' }}>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <h1 style={{ textAlign: 'center' }}>XIN VUI LÒNG CHỌN</h1>
          <Nav fill variant="pills" className="flex-column flex-lg-row">
            <Col md={12}>
              <Row>
                {permission[0] === '1' &&
                  <Col md={6}>
                    <Nav.Item>
                      <Nav.Link eventKey="home" href={Routes.CartWaiting.path} className="mb-sm-3 mb-md-0" style={{ backgroundColor: 'blue' }}>
                        <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 25, color: '#fff' }}>
                          VÉ TÀU
                        </Container>
                      </Nav.Link>
                    </Nav.Item>
                  </Col>
                }
                <Col lg={6}>
                  <Nav.Item>
                    <Nav.Link eventKey="settings" onClick={handleLogout} className="mb-sm-3 mb-md-0" style={{ backgroundColor: 'grey' }}>
                      <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 25, color: '#fff' }}>
                        ĐĂNG XUẤT
                      </Container>
                    </Nav.Link>
                  </Nav.Item>
                </Col>
              </Row>
            </Col>
          </Nav>
        </Container>
      </section>
    </main>
  );
};
